import EsriJSON from 'ol/format/EsriJSON';
import { bbox } from 'ol/loadingstrategy';
import VectorSource from 'ol/source/Vector';
import { MapLayerType } from '../../layers/MapLayer';
import { normalizeLayerUrl } from '../../layers/rendering/createMapLayerFromConfig';

interface IIntersactableWidgetConfig {
  type?: MapLayerType;
  url?: string;
}

// TODO Supportare WFS
export function createIntersectionVectorSource(
  intersection?: IIntersactableWidgetConfig,
) {
  if (!intersection?.url || !intersection.type) return new VectorSource();

  const baseUrl = normalizeLayerUrl(intersection.url);
  const source = new VectorSource({
    format: new EsriJSON(),
    url: function (extent, resolution, projection) {
      console.log(`[createIntersectionVectorSource] extent`, extent);
      // ArcGIS Server vuole solamente la parte numerica del SRID
      const srid = 102100;
      const url =
        baseUrl +
        '/query/?f=json&' +
        'returnGeometry=true&spatialRel=esriSpatialRelIntersects&geometry=' +
        encodeURIComponent(
          '{"xmin":' +
            extent[0] +
            ',"ymin":' +
            extent[1] +
            ',"xmax":' +
            extent[2] +
            ',"ymax":' +
            extent[3] +
            '}',
        ) +
        '&geometryType=esriGeometryEnvelope&inSR=' +
        srid +
        '&outFields=*' +
        '&outSR=' +
        srid;

      return url;
    },
    strategy: bbox,
  });

  return source;
}
